import { ChangeVehicleInterstate } from '@makemydeal/dr-activities-change-vehicle';
import { SelectedVehicleInfo } from './SelectedVehicleInfo';
import {
    OpenDealCardInfo,
    StyledAccordionContainer,
    StyledAccordionTitle,
    StyledAccordionHeader,
    StyledAccordionHeaderTitleContainer
} from '../Activity.style';
import type { VehiclePickerProps } from '../../types/VehiclePickerProps';
import { Accordion, AccordionDetails, AccordionSummary } from '@interstate/components/AccordionGroup';
import { ExclamationCircleIcon } from '@interstate/components/Icons';
import { Typography } from '@interstate/components/Typography';

export const VehiclePicker = ({ selectedVehicle, editMode, onEditModeChange }: VehiclePickerProps) => {
    return (
        <StyledAccordionContainer>
            <Accordion
                className="custom-accordion"
                onChange={onEditModeChange}
                expanded={editMode}
                data-testid="vehicle-picker-accordion"
            >
                <AccordionSummary chevronPosition="right" className="custom-accordion-summary-hide-icon">
                    <StyledAccordionHeader>
                        <StyledAccordionTitle>
                            <StyledAccordionHeaderTitleContainer>
                                <ExclamationCircleIcon />
                                <Typography variant="h6">Vehicle</Typography>
                            </StyledAccordionHeaderTitleContainer>
                            <Typography className="editToggle" variant="h6">
                                {editMode ? 'Close' : 'Edit'}
                            </Typography>
                        </StyledAccordionTitle>
                        {!editMode && (
                            <OpenDealCardInfo>
                                <SelectedVehicleInfo selectedVehicle={selectedVehicle!} />
                            </OpenDealCardInfo>
                        )}
                    </StyledAccordionHeader>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '16px' }}>
                    <ChangeVehicleInterstate enableConfirmModal={false} forceSmallBreakpoint />
                </AccordionDetails>
            </Accordion>
        </StyledAccordionContainer>
    );
};
